import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Sun, Moon, Sunrise, Sparkles, ArrowRight } from "lucide-react";

export default function Preview() {
  const nav = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    const raw = sessionStorage.getItem("mynsight_preview");
    if (!raw) { nav("/setup"); return; }
    setData(JSON.parse(raw));
  }, [nav]);

  if (!data) return null;
  const n = data.natal || {};
  const hd = data.human_design || {};
  const num = data.numerology || {};
  const chin = data.chinese || {};

  return (
    <div className="min-h-screen star-field celestial px-6 py-16">
      <div className="max-w-3xl mx-auto">
        <p className="overline text-center mb-3">Your first glimpse</p>
        <h1 className="font-serif text-5xl text-center mb-10">Here is the shape of you.</h1>

        {data.insight && (
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
            data-testid="preview-insight" className="panel p-8 mb-8 relative overflow-hidden">
            <Sparkles className="text-primary mb-3" size={20} />
            <p className="font-serif text-2xl leading-snug text-foreground/90 italic">"{data.insight}"</p>
          </motion.div>
        )}

        <div className="grid sm:grid-cols-2 gap-4 mb-10">
          <div className="panel p-6">
            <p className="overline mb-4">Astrology</p>
            <div className="flex items-center gap-2 mb-2"><Sun size={16} className="text-primary" /> {n.sun_sign} Sun</div>
            <div className="flex items-center gap-2 mb-2"><Moon size={16} className="text-primary" /> {n.moon_sign} Moon</div>
            <div className="flex items-center gap-2"><Sunrise size={16} className="text-primary" /> {n.rising_sign || "—"} Rising</div>
          </div>
          <div className="panel p-6">
            <p className="overline mb-4">Human Design</p>
            <div className="font-serif text-2xl text-primary">{hd.type}</div>
            <p className="text-sm text-muted-foreground">{hd.authority} authority · {hd.profile}</p>
          </div>
          <div className="panel p-6">
            <p className="overline mb-4">Numerology</p>
            <div className="font-serif text-3xl text-primary">Life Path {num.life_path}</div>
          </div>
          <div className="panel p-6">
            <p className="overline mb-4">Chinese Zodiac</p>
            <div className="font-serif text-2xl text-primary">{chin.polarity} {chin.element} {chin.animal}</div>
          </div>
        </div>

        <div className="panel p-8 text-center">
          <h2 className="font-serif text-3xl mb-3">This is just the surface.</h2>
          <p className="text-muted-foreground mb-6 max-w-md mx-auto">Create your companion to unlock the full synthesis, memory, daily guidance and your growth map.</p>
          <Link to="/auth" data-testid="preview-signup-btn" className="gold-btn inline-flex items-center gap-2 px-8 py-4 rounded-full font-medium">
            Create my companion <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </div>
  );
}
